<template>
	<div class="patentView">
		<div class="patentTopView">
			<div class="topView-name">{{name + '(' +introduceAry.length + ')'}}</div>
			<div class="topView-svg" @click="dropDown" :style="'transform: rotate(' + deg+'deg)'"><SvgIcon svg-name="dropDown" size="40"></SvgIcon></div>
		</div>
		<div class="centerView" v-show="Down">
			<div class="centerView-left">
				<div class="centerView-box"  v-for="(item,num) in itemAry[index]">
					<div class="centerView-box-number"><span>{{item.patent_num}}</span></div>
					<div class="centerView-box-describe">{{item.patent_name}}</div>
				</div>
			</div>
			<div class="centerView-rigth">
				<div class="centerView-rigth-bottom" :style="itemAry.length > 1 ? '' : 'background-color: rgba(225,225,225,0.5);' " @click="clickBtn(index)">
					<div v-if="itemAry.length > 1 "><SvgIcon svg-name="signRightBlack" size="40"></SvgIcon></div>
					<div v-else><SvgIcon svg-name="signRightWhite" size="40"></SvgIcon></div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	
	import SvgIcon from "./SvgIcon.vue"
	
	
	export default{
		name:'patentView',
		components:{
			SvgIcon,
		},
		data(){
			return{
				itemAry:[],
				Down:false,
				index:0,
				deg:0,
				maxNum:0,
			}
		},
		props:{
			name:{
				type:String,
			},
			introduceAry:{
				type:Array,
			}
		},
		methods:{
			dropDown(){
				let that = this;
				
				if(that.Down){
					that.deg = 0;
				}else{
					that.deg = 180;
				}
				that.Down = !that.Down
			},
			clickBtn(){
				if(this.index <= this.maxNum){
					this.index++;
				}else{
					this.index = 0;
				}
			}
		},
		created() {
			let that = this
			let num = Math.ceil(that.introduceAry.length/5)
			for (let i = 0; i < num; i++) {
				let ary = that.introduceAry.slice(5*i,5*i+5)
				that.itemAry.push(ary);
			}
			console.log('1'+that.introduceAry);
			console.log(that.index);
			that.maxNum = that.itemAry.length - 2;
			
		}
		
	}
	
</script>

<style>
	
	.patentView {
		background-color: rgba(244,244,244,1);
		width: 96%;
		margin: 0 auto;
		margin-top: 0.625rem;
	}
	
	.patentView .patentTopView{
		width: 100%;
		height: 3.875rem;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
	
	.patentView .patentTopView .topView-name{
		font-size: 1rem;
		margin-left: 1.625rem;
		font-weight: 500;
	}
	
	.patentView .patentTopView .topView-svg{
		margin-right: 1.625rem;
	}
	
	.patentView .centerView {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 100%;
		left: 0;
	}
	
	.patentView .centerView .centerView-left{
		display: flex;
		width: 50%;
		flex-direction: column;
	}
	
	.patentView .centerView .centerView-left .centerView-box{
		display: flex;
		flex-direction: column;
		padding-top: 1rem;
		padding-bottom: 1rem;
		padding-left: 1.625rem;
		color:rgba(95,95,95,1);
		width: 100%;
		font-size: 0.75rem;
		text-align: left;
	}
	
	.patentView .centerView .centerView-left .centerView-box .centerView-box-number{
		
	}
	.patentView .centerView .centerView-left .centerView-box .centerView-box-number span{
		border-bottom: #5F5F5F 1px solid;
	}
	
	.patentView .centerView .centerView-left .centerView-box .centerView-box-describe{
		padding-top: 0.36rem;
	}
	
	.patentView .centerView .centerView-rigth {
		width: 50%;
		margin: 0;
		right: 0;
		position: relative;
	}
	
	.patentView .centerView .centerView-rigth .centerView-rigth-bottom{
		width: 60%;
		height: 2.5rem;
		background-color: rgba(0,0,0,0.1);
		bottom: 5%;
		right: 10%;
		position: absolute;
	}
	
</style>
